<template>
  <div id="user-management">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>User Management</li>
      <li class="active">Daftar User</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">User Management</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              Daftar User
            </div>
            <div>
              <!-- <button class="btn btn-success" style="padding:5px; font-size: 11px;" @click="$router.push('/user-management/bulk-activation')">Aktivasi User</button> -->
            </div>
          </div>
          <div class="panel-body">
            <div class="searchbox" style="display:flex;align-items:center;">
              <div class="input-group">
                <input type="text" class="form-control" v-model="query" @keyup.enter="loadUserData(1)" placeholder="Masukkan kata kunci dan tekan enter">
                <div class="input-group-btn">
                  <button class="btn btn-success" style="height:34px; padding:5px 15px 5px 15px; font-size: 11px;" @click="loadUserData(1)">Search</button>
                </div>
              </div>
              <div>
                <button class="btn btn-success" style="height:34px; padding:5px 15px 5px 15px; font-size: 11px; margin: 0px 10px 0px 10px; " @click="showFilter()">Filter</button>
              </div>
              
            </div>
            <div style="padding: 10px;">
              FILTER : 
                <button class="btn btn-info">
                  Order: {{ this.filter.order}}
                </button>

                <button class="btn btn-info">
                  Order By: {{ this.filter.orderby}}
                </button>

                <button @click="eraseFilter('grade')" class="btn btn-info" v-if="filter.grade !== ''">
                  <i class="fa fa-close"></i>
                  Kelas: {{ this.filter.grade}}
                </button>

                <button @click="eraseFilter('npsn')" class="btn btn-info" v-if="filter.npsn !== ''">
                  <i class="fa fa-close"></i>
                  NPSN: {{ this.filter.npsn}}
                </button>

                <button @click="eraseFilter('type')" class="btn btn-info" v-if="filter.type !== ''">
                  <i class="fa fa-close"></i>
                  Jenis Sekolah: {{ this.filter.type}}
                </button>
              </div>
            
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <!-- <th>Student Number</th> -->
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>School</th>
                  <th>Kelas</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, key) in users" v-bind:key="key" @dblclick="goToDetail(key)">
                  <td>{{(25 * (pageNumber - 1)) + (key + 1)}}</td>
                  <!-- <td>{{row.student_number ? row.student_number.toUpperCase() : '-'}}</td> -->
                  <td>{{row.name.toUpperCase()}}</td>
                  <td>{{row.email.toUpperCase()}}</td>
                  <td>{{row.phone_number}}</td>
                  <td>{{row.school ? row.school.toUpperCase() : '-'}}</td>
                  <!-- <td>{{row.is_nf_student ? 'Siswa NF' : '-'}}</td> -->
                  <td>{{ row.grade }}</td>
                  <td>
                    <button class="btn btn-info" @click="showChangePassword(row)">
                      <i class="fa fa-key"></i>
                    </button>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="panel-footer">
            <div class="btn-group">
              <button class="btn btn-white" type="button" @click="loadUserData(--pageNumber)">
                Previous
              </button>
              <input type="text" class="form-control" v-model="pageNumber" style="width: 50px; text-align: center">
              <button class="btn btn-white" type="button" @click="loadUserData(++pageNumber)">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <div class="modal fade bs-example-modal-sm" id="modalFilter" tabindex="-1" role="dialog" aria-labelledby="FilterModal" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document" style="max-width: 300px !important; ">
        <div class="modal-content">
          <div class="modal-header" style="display:flex; justify-content:space-between;">
            <h4 id="exampleModalLongTitle">Filter Data User</h4>
            <button type="button" class="close" data-dismiss="modal" style="position:absolute;right:15px;" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin:0;">
            <div class="list-group">
              <form action="submit">
                <label for="basic-url">Order</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <select class="form-control" v-model="filter.order">
                    <option value="ASC" >Ascending</option>
                    <option value="DESC">Descending</option>
                  </select>
                </div>

                <label for="basic-url">Order By</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <select class="form-control" v-model="filter.orderby">
                    <option value="id" >ID</option>
                    <option value="name">Nama</option>
                  </select>
                </div>
                <label for="basic-url">Kelas</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <select class="form-control" v-model="filter.grade">
                    <option :value="i" v-for="i in [4,5,6,7,8,9,10,11,12]" :key="i">Kelas {{ i  }}</option>
                    <option value="">Semua Kelas</option>
                  </select>
                </div>

                <label for="basic-url">NPSN</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <select class="form-control" v-model="filter.npsn">
                    <option value="NOT_NULL">Ada</option>
                    <option value="NULL">Tidak Ada</option>
                    <option value="ALL">Semua</option>
                  </select>
                </div>

                <label for="basic-url">Jenis Sekolah</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <select class="form-control" v-model="filter.type">
                    <option value="FORMAL">Formal</option>
                    <option value="INFORMAL">Informal</option>
                    <option value="">Semua</option>
                  </select>
                </div>

                <div>
                  <button type="button" class="btn btn-success" style="padding:5px; font-size: 11px;" @click="applyFilter()">Aktifkan Filter</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- MODAL CHANGE PASSWORD -->
    <div class="modal fade bs-example-modal-sm" id="modalChangepassword" tabindex="-1" role="dialog" aria-labelledby="FilterModal" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document" style="max-width: 300px !important; ">
        <div class="modal-content">
          <div class="modal-header" style="display:flex; justify-content:space-between;">
            <h4 id="exampleModalLongTitle">Ubah password user</h4>
            <button type="button" class="close" data-dismiss="modal" style="position:absolute;right:15px;" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin:0;">
            <div class="list-group">
              <form action="submit">
                <label for="basic-url">Anda akan mengubah password untuk </label>
                <p style="font-size: 15px;color: black;"><strong>{{userData.name + ' - ' + userData.email}}</strong></p><br/>
                <label for="basic-url">Masukkan password baru</label>
                <div class="input-group" style="margin-bottom: 20px;">
                      <input
                        placeholder="Masukkan password baru"
                        :type="seeNewPass ? 'text' : 'password'"
                        v-model="newPassword"
                        class="form-control"
                      />
                      <span class="input-group-btn">
                        <button v-if="!seeNewPass" @click="seeNewPass = true" class="btn btn-success" type="button">
                          <i class="fa fa-eye"></i>
                        </button>
                        <button v-if="seeNewPass" @click="seeNewPass = false" class="btn btn-success" type="button">
                          <i class="fa fa-eye-slash"></i>
                        </button>
                      </span>
                </div>
                <label for="basic-url">Konfirmasi password baru</label>
                <div class="input-group" style="margin-bottom: 20px;">
                      <input
                        placeholder="Masukkan password baru"
                        :type="seeConfirmPass ? 'text' : 'password'"
                        v-model="confirmPassword"
                        class="form-control"
                      />
                      <span class="input-group-btn">
                        <button v-if="!seeConfirmPass" @click="seeConfirmPass = true" class="btn btn-success" type="button">
                          <i class="fa fa-eye"></i>
                        </button>
                        <button v-if="seeConfirmPass" @click="seeConfirmPass = false" class="btn btn-success" type="button">
                          <i class="fa fa-eye-slash"></i>
                        </button>
                      </span>
                </div>
                <div>
                  <button type="button" class="btn btn-success" style="padding:5px; font-size: 11px;" @click="submitChangePassword()">Ubah Password</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import AppSpinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'
export default {
  name: 'user-management',
  components: {
    'app-spinner': AppSpinner,
    'app-modal': Modal,
  },
  data: function () {
    return {
      query: '',
      isLoading: false,
      pageNumber: 1,
      users: [],
      userData: {
        name: null,
        id: null
      },
      newPassword: null,
      confirmPassword: null,
      seeNewPass: false,
      seeConfirmPass: false,
      filter: {
        grade: '',
        npsn: '',
        type: '',
        order: 'DESC',
        orderby: 'id'
      }
    }
  },
  watch: {
    pageNumber: function(newVal) {
      this.loadUserData(newVal)
    }
  },
  methods: {
    loadUserData: function (pageNumber = 1) {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/usman/users'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      var objParams = '{"page": ' + pageNumber 
      if(this.query !== '') objParams += ', "query": "' + this.query + '"'
      if(this.filter.grade !== '') objParams += ', "grade": ' + parseInt(this.filter.grade)
      if(this.filter.npsn !== '') objParams += ', "npsn": "' + this.filter.npsn + '"'
      if(this.filter.type !== '') objParams += ', "school_type": "' + this.filter.type + '"'
      if(this.filter.order !== '') objParams += ', "order": "' + this.filter.order + '"'
      if(this.filter.orderby !== '') objParams += ', "order_by": "' + this.filter.orderby + '"'

      objParams += '}'
      http.get(url, {
        params: JSON.parse(objParams)
      }) 
      .then(function(response) {
        context.users = response.data
        sessionStorage.setItem('filter', JSON.stringify(context.filter))
        $('#modalFilter').modal('hide')
        
      })
      .catch(function (error) {
        console.log(error.message)
        $('#modalFilter').modal('hide')
      })
      .then(function() {
        context.isLoading = false
      })
    },
    goToDetail: function(index) {
      this.$store.commit('usman_init', this.users[index])
      sessionStorage.setItem('usman_init', JSON.stringify(this.users[index]))
      this.$router.push('user-detail')
    },
    submitChangePassword(){
      console.log(this.userData)
      var context = this
          if(context.newPassword === null || context.confirmPassword === null){
            alert('password wajib diisi')
          }else if(context.newPassword !== context.confirmPassword){
            alert('Password konfirmasi tidak valid')
          } else {
            if (confirm("Anda yakin akan mengubah password data ini?") == true) {
            var token = this.$ls.get('token');
            var url = process.env.API_BASE_URL + '/account/usman/user/' + context.userData.user_id +'/password'
      
            context.isLoading = true
            var http = axios.create({
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })

            
            http.put(url, {'password': context.confirmPassword })
            .then(function (response) {
              $('#modalChangepassword').modal('hide')
              alert('Password berhasil diperbaharui')
            })
            .catch(function (error) {
              alert('Password gagal diperbaharui')
            })
            .then(function () {
              context.isLoading = false
            })
          }
          }
    },
    showFilter(){
      $('#modalFilter').modal('show')
    },
    applyFilter(){
      this.pageNumber = 1
      this.loadUserData()
    },
    eraseFilter(k){
      this.filter[k] = ''
      this.applyFilter()
    },
    showChangePassword(v){
      this.userData = v
      $('#modalChangepassword').modal('show')
      
    },
  },
  mounted: function () {
    if(sessionStorage.filter) this.filter = JSON.parse(sessionStorage.filter)
    this.loadUserData()
  }
}
</script>




// WEBPACK FOOTER //
// UserManagement.vue?7dfbc7b8